<template>
  <div class="online-capacity">
    <div class="statis-status-work">
      <el-row>
        <el-col :span="11">
          <div class="grid-content-work">
            <p>线上订单工作产能</p>
            <div>
              <DatePicker :type="picType" :date-type="selectType" @change-picker="handleDateChange"></DatePicker>
            </div>
          </div>
          <div ref="capacityChart" style="height: 280px;width:100%;max-width:600px"></div>
        </el-col>
        <el-col :span="13">
          <div class="grid-content bg-purple-light">
            <p>当前工作量</p>
            <div ref="workloadChart" style="height: 300px;"></div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple-dark">
            <p>今日预警 <span class="warning-hint">（点击柱状图查看详情）</span></p>
            <div ref="warningChart" style="height: 300px;"></div>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-dialog
      :title="detailDialogTitle"
      :visible.sync="detailVisible"
      width="960px"
      append-to-body
      top="8vh"
      @closed="handleDetailClosed"
    >
      <el-table
        v-loading="detailLoading"
        :data="detailList"
        border
        size="small"
        max-height="480"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column prop="orderSn" label="订单编号" width="160">
          <template slot-scope="scope">
            <el-link
              type="primary"
              :underline="false"
              :disabled="orderDetailLoading"
              @click="openOrderDetail(scope.row)"
            >
              {{ scope.row.orderSn }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column
          v-if="detailType === 'order'"
          prop="productName"
          label="商品名称"
          min-width="120"
          show-overflow-tooltip
        />
        <el-table-column
          v-if="detailType === 'item'"
          prop="productName"
          label="衣物名称"
          min-width="120"
          show-overflow-tooltip
        />
        <el-table-column
          v-if="detailType === 'order'"
          prop="status"
          label="订单状态"
          width="110"
        >
          <template slot-scope="scope">
            {{ orderStatus(scope.row.status) }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="detailType === 'order'"
          prop="channelName"
          label="渠道"
          width="100"
        />
        <el-table-column
          v-if="detailType === 'order'"
          prop="receiverName"
          label="收货人"
          width="90"
        />
        <el-table-column
          v-if="detailType === 'order'"
          prop="receiverPhone"
          label="电话"
          width="120"
        />
        <el-table-column
          v-if="detailType === 'order'"
          prop="payTime"
          label="下单时间"
          width="160"
        />
        <el-table-column
          v-if="detailType === 'item'"
          prop="washingCode"
          label="水洗码"
          width="130"
        />
        <el-table-column
          v-if="detailType === 'item'"
          prop="sortingUserName"
          label="分检员"
          width="90"
        />
        <el-table-column
          v-if="detailType === 'item'"
          prop="enterFactoryTime"
          label="入厂时间"
          width="160"
        />
        <el-table-column
          v-if="detailType === 'item'"
          prop="sortingTime"
          label="分检时间"
          width="160"
        />
        <el-table-column prop="exFactoryTime" label="出厂时间" width="160" />
      </el-table>
      <Pageing
        :total="detailPage.total"
        :page-size="detailPage.pageSize"
        :page-num="detailPage.pageNum"
        @CurrentChange="handleDetailPageChange"
        @SizeChange="handleDetailSizeChange"
      />
    </el-dialog>

    <OrderDetails
      :visible.sync="orderDialogVisible"
      :my-order="orderData"
    />
  </div>
</template>

<script>
import {
  getDayOrderStatus,
  getEWOrderStatus,
  getEWOrderStatusDetail,
  getEWOrderItemStatusDetail,
  getWorkOrderStatus
} from "@/api/statistics.js";
import { getOrderSn } from "@/api/order.js";
import DatePicker from "@/components/range/DatePicker.vue";
import Pageing from "@/components/pageing/Pageing.vue";
import OrderDetails from "@/components/order/OrderDetails.vue";
import {
  createChartRegistry,
  bindChartResize,
  unbindChartResize
} from "@/unit/chartManager.js";
import { runStatisticsRequest } from "@/unit/offlineStatsHelper.js";

const defaultStartEnd = {
  startDate: "",
  endDate: ""
};

export default {
  name: "OnlineCapacity",
  components: {
    DatePicker,
    Pageing,
    OrderDetails
  },
  data() {
    return {
      picType: "date",
      selectType: "date",
      formInline: Object.assign({}, defaultStartEnd),
      capacityData: [],
      warningData: [],
      workloadData: [],
      chartRegistry: createChartRegistry(),
      detailVisible: false,
      detailLoading: false,
      detailType: "order",
      detailEwType: null,
      detailCategoryName: "",
      detailList: [],
      detailPage: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      orderDialogVisible: false,
      orderData: {},
      orderDetailLoading: false
    };
  },
  computed: {
    detailDialogTitle() {
      const typeLabel = this.detailType === "order" ? "订单" : "衣物";
      return `${this.detailCategoryName} - ${typeLabel}详情`;
    }
  },
  mounted() {
    bindChartResize(this, this.chartRegistry);
    this.getWorkload();
    this.getWarning();
  },
  activated() {
    this.$nextTick(() => this.chartRegistry.resize());
  },
  beforeDestroy() {
    unbindChartResize(this);
    this.chartRegistry.dispose();
  },
  methods: {
    async refresh() {
      const tasks = [this.getWorkload(), this.getWarning()];
      if (this.formInline.startDate) {
        tasks.push(this.getCapacity());
      }
      await Promise.all(tasks);
    },
    handleDateChange(startDate, endDate) {
      this.formInline.startDate = startDate;
      this.formInline.endDate = endDate;
      this.getCapacity();
    },
    async getCapacity() {
      await runStatisticsRequest(this, getDayOrderStatus, this.formInline, {
        errorMessage: "获取产能数据失败",
        emptyFallback: [],
        onSuccess: (data) => {
          this.capacityData = data;
          this.capacityCharts(data);
        }
      });
    },
    async getWorkload() {
      await runStatisticsRequest(this, getWorkOrderStatus, undefined, {
        errorMessage: "获取工作量数据失败",
        emptyFallback: [],
        onSuccess: (data) => {
          this.workloadData = data;
          this.workloadCharts(data);
        }
      });
    },
    async getWarning() {
      await runStatisticsRequest(this, getEWOrderStatus, undefined, {
        errorMessage: "获取预警数据失败",
        emptyFallback: [],
        onSuccess: (data) => {
          this.warningData = data;
          this.warningCharts(data);
        }
      });
    },
    warningCharts(data) {
      const list = Array.isArray(data) ? data : [];
      const names = list.map(item => item.name);
      const orderSum = list.map(item => Number(item.statisticsSum) || 0);
      const orderItemSum = list.map(item => Number(item.statisticsItemSum) || 0);

      this.chartRegistry.setOption(
        this,
        "warningChart",
        {
          tooltip: { trigger: "axis" },
          legend: { data: ["订单数", "衣物数"] },
          xAxis: {
            type: "category",
            data: names,
            axisLabel: { interval: 0 }
          },
          yAxis: { type: "value", name: "个/件" },
          series: [
            {
              name: "订单数",
              data: orderSum,
              type: "bar",
              color: "#3B82F6",
              label: { show: true, position: "top" }
            },
            {
              name: "衣物数",
              data: orderItemSum,
              type: "bar",
              color: "#F97316",
              label: { show: true, position: "top" }
            }
          ]
        },
        this.handleWarningChartClick
      );
    },
    handleWarningChartClick(params) {
      const value = Number(params.value) || 0;
      if (value <= 0) {
        this.$message.info("该项暂无数据");
        return;
      }
      const ewType = params.dataIndex + 1;
      const category = this.warningData[params.dataIndex];
      this.detailCategoryName = (category && category.name) || params.name;
      this.detailEwType = ewType;
      this.detailType = params.seriesName === "订单数" ? "order" : "item";
      this.detailPage.pageNum = 1;
      this.detailVisible = true;
      this.fetchWarningDetail();
    },
    async fetchWarningDetail() {
      this.detailLoading = true;
      const params = {
        ewType: this.detailEwType,
        pageNum: this.detailPage.pageNum,
        pageSize: this.detailPage.pageSize
      };
      const api =
        this.detailType === "order"
          ? getEWOrderStatusDetail
          : getEWOrderItemStatusDetail;
      try {
        const { data: res } = await api(params);
        if (res.code === 200 && res.data) {
          this.detailList = res.data.list || [];
          this.detailPage.total = res.data.total || 0;
        } else {
          this.detailList = [];
          this.detailPage.total = 0;
          this.$message.error(res.message || "获取详情失败");
        }
      } catch (e) {
        this.detailList = [];
        this.detailPage.total = 0;
        this.$message.error("获取详情失败");
      } finally {
        this.detailLoading = false;
      }
    },
    handleDetailPageChange(pageNum) {
      this.detailPage.pageNum = pageNum;
      this.fetchWarningDetail();
    },
    handleDetailSizeChange(pageSize) {
      this.detailPage.pageSize = pageSize;
      this.detailPage.pageNum = 1;
      this.fetchWarningDetail();
    },
    handleDetailClosed() {
      this.detailList = [];
      this.detailPage.total = 0;
      this.detailPage.pageNum = 1;
      this.detailEwType = null;
    },
    async openOrderDetail(row) {
      if (!row || !row.orderSn || this.orderDetailLoading) {
        return;
      }
      this.orderDetailLoading = true;
      try {
        const { data: res } = await getOrderSn(row.orderSn);
        if (res.code === 200 && res.data) {
          this.orderData = res.data;
          this.orderDialogVisible = true;
        } else {
          this.$message.error(res.message || "获取订单详情失败");
        }
      } catch (e) {
        this.$message.error("获取订单详情失败");
      } finally {
        this.orderDetailLoading = false;
      }
    },
    orderStatus(v) {
      const status = v === null || v === undefined || v === "" ? null : Number(v);
      switch (status) {
        case 0:
          return "已付款";
        case 1:
          return "待取件";
        case 2:
          return "已取件(揽件)";
        case 3:
          return "已取件(在途)";
        case 4:
          return "已取件(派送)";
        case 5:
          return "已入厂";
        case 6:
          return "已分检";
        case 7:
          return "已总检";
        case 8:
          return "已出厂";
        case 9:
          return "送件中(揽件)";
        case 10:
          return "送件中(在途)";
        case 11:
          return "送件中(派送)";
        case 12:
          return "已完成";
        case 13:
          return "已取消";
        case 14:
          return "客户取消寄件";
        case 15:
          return "已拒单";
        default:
          return "";
      }
    },
    workloadCharts(data) {
      const list = Array.isArray(data) ? data : [];
      const names = list.map(item => item.name);
      const orderSum = list.map(item => item.statisticsSum);
      const orderItemSum = list.map(item => item.statisticsItemSum);

      this.chartRegistry.setOption(this, "workloadChart", {
        tooltip: { trigger: "axis" },
        legend: { data: ["订单数", "衣物数"] },
        xAxis: {
          type: "category",
          data: names,
          axisLabel: { interval: 0 }
        },
        yAxis: { type: "value", name: "个/件" },
        series: [
          {
            name: "订单数",
            data: orderSum,
            type: "line",
            smooth: true,
            color: "#3B82F6",
            label: { show: true, position: "top" }
          },
          {
            name: "衣物数",
            data: orderItemSum,
            type: "line",
            smooth: true,
            color: "#F97316",
            label: { show: true, position: "top" }
          }
        ]
      });
    },
    capacityCharts(data) {
      const list = Array.isArray(data) ? data : [];
      const names = list.map(item => item.name);
      const orderSum = list.map(item => item.statisticsSum);
      const orderItemSum = list.map(item => item.statisticsItemSum);

      this.chartRegistry.setOption(this, "capacityChart", {
        tooltip: { trigger: "axis" },
        legend: { data: ["订单数", "衣物数"] },
        xAxis: { type: "category", data: names },
        yAxis: { type: "value", name: "个/件" },
        series: [
          {
            name: "订单数",
            data: orderSum,
            type: "line",
            smooth: true,
            color: "#3B82F6",
            label: { show: true, position: "top" }
          },
          {
            name: "衣物数",
            data: orderItemSum,
            type: "line",
            smooth: true,
            color: "#F97316",
            label: { show: true, position: "top" }
          }
        ]
      });
    }
  }
};
</script>

<style scoped lang="less">
.online-capacity {
  .statis-status-work {
    .grid-content-work {
      margin-bottom: 10px;
      display: flex;
      align-items: center;
    }
    p {
      font-weight: bold;
      margin-right: 20px;
      font-size: 20px;
    }
    .warning-hint {
      font-size: 13px;
      font-weight: normal;
      color: #86909c;
    }
  }
}
</style>
